mutation DeletePlatforms($ids: [ID!]!) {
  deletePlatforms(ids: $ids) {
    id
  }
}

